module.exports = __webpack_public_path__ + "img/logo.40bd19b9.png";